import { sideConfig } from './config-sidebar';
import { Stack as MuiStack, useTheme } from '@mui/material';
import { ReactComponent as ForwardBtn } from '@assets/icons/ic-eva_arrow-ios-forward-fill.svg';
import * as S from './Sidebar.styles';
import Logo from '@atoms/Logo';
import { useNavigate } from 'react-router-dom';
import SidebarList from './SidebarList';
import { useLayoutSettingContext } from '@contexts/LayoutSettingContext';
import { Typography } from '@atoms/Typography';
import { useResponsive } from '@hook/useResponsive';

export const Sidebar = () => {
  const data = sideConfig;
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const navigate = useNavigate();

  const { isMini, handleClickSidebarModeToggle } = useLayoutSettingContext();

  const renderSidebar = (
    <>
      {data.map((group) => {
        return (
          <S.SidebarContainer key={group.subheader} isMini={isMini}>
            {/** Logo */}
            <MuiStack
              padding={
                isMini ? theme.spacing(3, 0, 2, 0) : theme.spacing(3, 2, 1, 2)
              }
              justifyContent={isMini ? 'center' : undefined}
              alignItems={isMini ? 'center' : undefined}
            >
              <MuiStack
                sx={{
                  width: isMini ? '26px' : '240px',
                  height: '100%',
                  cursor: 'pointer',
                }}
                onClick={() => navigate('/')}
              >
                <Logo
                  variant={isMini ? 'mini' : 'full'}
                  // width={isMini ? 31.4 : 40}
                  // height={31.4}
                  data-testid="FullPrimary"
                />
              </MuiStack>
            </MuiStack>
            {/** Sub Header */}
            {!isMini && (
              <Typography
                variant="caption"
                sx={{
                  padding: theme.spacing(1.5, 0, 1, 1.5),
                  color: theme.palette.text.disabled,
                  fontWeight: '700',
                }}
              >
                {group.subheader.toUpperCase()}
              </Typography>
            )}
            {/** SideList */}
            {group.items.map((list) => (
              <SidebarList
                key={list.title + list.path}
                data={list}
                depth={1}
                hasChild={!!list.children}
                isMini={isMini}
              />
            ))}
          </S.SidebarContainer>
        );
      })}
    </>
  );

  if (isMobile) {
    return <>{renderSidebar}</>;
  }

  return (
    <MuiStack sx={{ width: '100%', height: '100%' }}>
      {renderSidebar}
      {/** Mini Btn */}
      <S.SidebarMiniBtn
        data-testid={'miniButton'}
        disableRipple
        isMini={isMini}
        onClick={handleClickSidebarModeToggle}
      >
        <ForwardBtn />
      </S.SidebarMiniBtn>
    </MuiStack>
  );
};

export default Sidebar;
